import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Button } from '@material-ui/core';

const DownloadAutoresponsePDFButton = ( props ) => {

    const handleClick = (e) => {
        e.preventDefault( );

        var submission_id = props.record.submission_id;
        if ( 'undefined' === typeof submission_id )
            submission_id = props.record.id;
        
        window.open( window.__rest_uri+'/v2-download-email-autoresponse/'+submission_id+'?type=pdf&authToken='+localStorage.getItem( 'authToken' ), '_blank' );
    };

    return (
        <React.Fragment>
            <Button variant="contained" color="secondary" onClick={handleClick}>PDF</Button>
        </React.Fragment>
    );
}

DownloadAutoresponsePDFButton.propTypes = {
    record: PropTypes.object
};

export default connect(null, { })(DownloadAutoresponsePDFButton);
